import changeSelectedFilePickerViewBasedOnUserPreferredView from './changeSelectedFilePickerViewBasedOnUserPreferredView';
import changeSelectedFolder from './changeSelectedFolder';
import clearFilePickerBreadcrumb from './clearFilePickerBreadcrumb';
import clearFileProviderItems from './clearFileProviderItems';
import pushFilePickerBreadcrumb from './pushFilePickerBreadcrumb';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import { FilePickerBreadcrumb } from '../store/schema/FilePickerViewState';
import { logUsage } from 'owa-analytics';
import { ClientOnlyFileProviderType, FileProviderViewState } from 'owa-fileprovider-store';
import { lazyEndSearchSession, lazyIsInSearchMode, SearchScenarioId } from 'owa-search';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import { action } from 'satcheljs/lib/legacy';
import { showFileProviderInlineView } from './internalActions';

export function createBreadcrumbForFileProvider(
    fileProvider: FileProviderViewState
): FilePickerBreadcrumb {
    return <FilePickerBreadcrumb>{
        id: fileProvider.model.Id,
        name: fileProvider.providerAccountIdentifier || fileProvider.name,
        associatedItem: null,
    };
}

function getDefaultScopeFromDataProvider(dataProvider: FileProviderViewState) {
    const defaultScopeIndex = dataProvider.model.DefaultScopeIndex || 0;
    return dataProvider.scopes[defaultScopeIndex];
}

export default action('changeSelectedFileProvider')(async function changeSelectedFileProvider(
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerPanelViewState,
    scope?: AttachmentDataProviderScope
) {
    showFileProviderInlineView(false);

    // If the selected folder is null then we are in the root directory of the data provider, so we shouldn't bother reloading the items when changing to
    // the same provider+scope combination. If it is defined we should navigate to the root as if changing to a new provider.
    if (
        selectedFileProvider === viewState.selectedFileProvider &&
        scope === viewState.selectedProviderScope &&
        viewState.filePickerViewState.selectedFolder === null
    ) {
        return;
    }

    const isInSearchMode = await lazyIsInSearchMode.import();
    if (isInSearchMode(SearchScenarioId.FilesPicker)) {
        const endSearchSession = await lazyEndSearchSession.import();
        endSearchSession(SearchScenarioId.FilesPicker);
    }

    viewState.selectedFileProvider = selectedFileProvider;
    viewState.selectedProviderScope = null;
    viewState.filePickerViewState.filterOptionsState.selectedFilterOption =
        AttachmentItemsFilterBy.None;

    const { filePickerViewState } = viewState;
    clearFilePickerBreadcrumb(filePickerViewState);

    if (selectedFileProvider) {
        const isWeSpace: boolean =
            selectedFileProvider.viewType === ClientOnlyFileProviderType.Groups;
        logUsage('FPLoadRootFolder', [isWeSpace, selectedFileProvider.type]);
        viewState.selectedProviderScope =
            scope || getDefaultScopeFromDataProvider(selectedFileProvider);

        changeSelectedFilePickerViewBasedOnUserPreferredView(
            selectedFileProvider,
            viewState.filePickerViewState
        );
        pushFilePickerBreadcrumb(
            createBreadcrumbForFileProvider(selectedFileProvider),
            filePickerViewState
        );
        changeSelectedFolder(null, viewState); // null folder means navigate to root
    }
    clearFileProviderItems(filePickerViewState);
});
